

<div class="login-container container-fluid">
  <div class="row">
    <div class="login-intro col-12 col-lg-7 order-2">
      <div class="login-copy">
        <div class="login-image">
          <adp-image imageKey="Global_Login_Main_Image" imageClass="main-spoe-image mx-auto d-block"></adp-image>
        </div>
      </div>
    </div>
    <div class="login col-12 col-lg-5 order-1">
      <div class="login-form">
        <div id="sign-in-widget">
          <adp-setting key="Login_Display_Header_As_Logo"></adp-setting>
          <h1 ifSettingTrue="Login_Display_Header_As_Logo" class="header-as-logo" title="{{headerAsLogoImageCaption}}">
            <adp-image imageKey="Global_Login_Header_Logo"></adp-image>
          </h1>
          <h1 ifSettingFalse="Login_Display_Header_As_Logo">
            <div class="header-semi-2xl header-text" *ngIf="!hasHeaderSubText"><adp-label labelKey="Login_Header_Text"></adp-label></div>
            <div *ngIf="hasHeaderSubText">
                <div class="header-bold-xl header-text" style="font-weight:600 !important;"><adp-label labelKey="Login_Header_Text"></adp-label></div>
                <div class="header-reg-m header-text"><adp-label labelKey="Login_Header_Sub_Text"></adp-label></div>
            </div>
          </h1>
          <p class="paragraph-body-l-reg">
            <adp-label labelKey="Login_Main_Text"></adp-label>
          </p>
        </div>
        <div class="signup-container text-center">
          <a href="javascript:void(0)" (click)="navigateToSignUp()" class="signup-link" [gtmClick]="getViewLabel('Login_SignUp_Link_Text')" [gtmLinkURL]="this.createAccountRoute()">
            <adp-label labelKey="Login_SignUp_Link_Text"></adp-label>
          </a>
        </div>
        <div ifSettingTrue="Assurant_Sold_Link_IsEnabled" class="assurant-sold-container">
          <adp-label labelKey="Signup_Mobile_Device_Insurance_Enrollment" style="font-weight:600;"></adp-label><br>
          <a href="{{xfinityAssurantSoldLink}}" class="signup-link" [gtmClick]="getViewLabel('Signup_Visit_AssurantSold_Account')" [gtmLinkURL]="xfinityAssurantSoldLink">
            <adp-label labelKey="Signup_Visit_AssurantSold_Account"></adp-label>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
